/* eslint-disable no-case-declarations */
import actionTypes from '../actions/actionsFactory/types';


export const INITIAL_STATE = {
  inmailData: { data: [], total: 0 },
  inmailModulsData: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_IN_MAIL_DATA:
      return { ...state, inmailData: { data: action.data.data, total: action.data.total } };
    case actionTypes.ADD_IN_MAIL_DATA:
      return { ...state, inmailData: { data: [action.data, ...state.inmailData.data], total: state.inmailData.total } };
    case actionTypes.UPATE_IN_MAIL_DATA_COUNT:
      const mods = state.inmailModulsData.map((mod) => (mod.moduleId === action.data.moduleId ? { ...mod, unReadNum: action.data.moduleNum } : mod));
      return { ...state, inmailModulsData: mods };
    case actionTypes.SET_IN_MAIL_MODULS_DATA:
      return { ...state, inmailModulsData: action.data };
    case actionTypes.SET_IN_MAIL_FRESH_DATA:
      return { ...state, inmailFreshData: action.data.data };
    case actionTypes.SET_IN_MAIL_UNREAD_COUNT:
      return { ...state, inmailUnreadData: action.data };
    case actionTypes.UPDATA_IN_MAIL_READ_STATUS:
      const data = state.inmailData.data.map((item) => {
        if (item.id === action.data) {
          return { ...item, status: 2 };
        }
        return item;
      }
      );
      return { ...state, inmailData: { data, total: state.inmailData.total } };
    default:
      return state;
  }
};
